// import React from "react";

// const Quilt = () => {
//   return (
//     <div className="bg-white text-black py-10 px-4 max-w-screen-xl mx-auto">
//       <div className="text-sm text-gray-600 mb-4">
//         <span className="underline">Ana Sayfa</span> &nbsp;&gt;&nbsp; <span className="underline">Hizmetler</span> &nbsp;&gt;&nbsp; Yorgan Yıkama
//       </div>

//       <h1 className="text-3xl text-center font-bold text-[#003132] mb-4">İstanbul YORGAN YIKAMA HİZMETİ</h1>

//       <div className="space-y-6">
//         <p>
//           İstanbul Temizlik Servisi olarak, yorgan yıkama hizmetimizi de İstanbul'nın dört bir yanına ulaştırıyoruz. Mevsim geçişlerinde temizliği gereken yorganlarınız için profesyonel, hijyenik ve güvenilir temizlik çözümleri sunuyoruz.
//         </p>

//         <p>
//           Yorganlar, hacimli yapıları nedeniyle evde yıkanması zor ürünlerdir. Özellikle makinede yıkanamayan, elyaf veya yün dolgulu yorganlar profesyonel bakım ister. Biz de bu özel ürünler için türüne uygun yıkama yöntemleri uyguluyoruz.
//         </p>

//         <p>
//           Özel sanayi tipi yorgan yıkama makinelerimiz, yüksek hijyen sağlayan deterjanlarımız ve deneyimli personelimiz ile yorganlarınızı tertemiz ve mis kokulu hale getiriyoruz.
//         </p>

//         <p>
//           Adresinizden teslim aldığımız yorganlarınızı yıkayıp kuruttuktan sonra, hijyenik ambalaj içerisinde geri teslim ediyoruz. Tüm süreç boyunca ürünlerinize özenle davranıyoruz.
//         </p>

//         <p>
//           İstanbul genelinde ücretsiz servis imkanıyla, yorgan yıkama hizmetimizden 7/24 randevu alabilirsiniz. Whatsapp hattımızdan hemen ulaşabilirsiniz.
//         </p>

//         <h2 className="text-xl font-bold text-[#003132]">🛌 Profesyonel Yorgan Yıkama Hizmeti</h2>
//         <p>
//           Yorganlarınız zamanla ter, toz, akar ve bakterilerle dolar. Yıkama işlemi sırasında hem görünür hem görünmeyen kirlerden tamamen arındırılır. İlk günkü hijyeni yeniden kazanır.
//         </p>

//         <h2 className="text-xl font-bold text-[#003132]">💧 Yorgan Yıkama Sürecimiz</h2>
//         <ol className="list-decimal list-inside space-y-2">
//           <li>Yorgan türü ve dolgu malzemesine göre sınıflandırma</li>
//           <li>Toz ve yüzey temizliği</li>
//           <li>Ön leke analizi ve müdahale</li>
//           <li>Endüstriyel makinelerde düşük ısıda yıkama</li>
//           <li>Doğal kurutma veya hava kontrollü kurutma</li>
//           <li>Son kalite kontrol ve özel ambalajlama</li>
//           <li>Adresinize teslimat</li>
//         </ol>

//         <h2 className="text-xl font-bold text-[#003132]">🧴 Kullandığımız Ürünler</h2>
//         <ul className="list-disc list-inside">
//           <li>Elyaf ve yün yorganlara özel deterjanlar</li>
//           <li>Antibakteriyel ve koku giderici temizlik ürünleri</li>
//           <li>Hassas dokulara zarar vermeyen doğal içerikler</li>
//         </ul>

//         <h2 className="text-xl font-bold text-[#003132]">✅ Neden Bizi Tercih Etmelisiniz?</h2>
//         <ul className="list-disc list-inside">
//           <li>Yorgan türüne uygun yıkama sistemleri</li>
//           <li>Modern makineler ve uzman personel</li>
//           <li>Ücretsiz servis ve zamanında teslimat</li>
//           <li>Hijyen garantili temizlik</li>
//           <li>Uygun fiyatlarla profesyonel hizmet</li>
//         </ul>

//         <p>
//           Yorganlarınızın hijyenini profesyonellere bırakın. Sağlıklı bir uyku ve uzun ömürlü yorgan kullanımı için bize güvenin. Hemen iletişime geçin, yorganlarınızı tertemiz teslim edelim.
//         </p>
//       </div>
//     </div>
//   );
// };

// export default Quilt;
import React from "react";
import LeftSidebar from "../../Sidebars/LeftSidebar";
import RightSidebar from "../../Sidebars/RightSidebar";

const Quilt = () => {
  return (
    <>
      <div className="max-w-7xl mx-auto py-6 px-4 grid grid-cols-1 lg:grid-cols-4 gap-8">
        {/* Sol Sidebar - sadece masaüstü için */}
        <div className="hidden lg:block">
          <LeftSidebar />
        </div>

        {/* Ana içerik */}
        <main className="lg:col-span-2">
          <div className="text-sm text-gray-600 mb-4">
            <span className="underline">Ana Sayfa</span> &nbsp;&gt;&nbsp; 
            <span className="underline">Hizmetler</span> &nbsp;&gt;&nbsp; Yorgan Yıkama
          </div>

          <h1 className="text-3xl text-center font-bold text-[#003132] mb-4">
            İstanbul YORGAN YIKAMA HİZMETİ
          </h1>

          <div className="space-y-6 text-gray-800 leading-relaxed">
            <p>
              İstanbul Temizlik Servisi olarak, yorgan yıkama hizmetimizi de İstanbul'nın dört bir yanına ulaştırıyoruz. Mevsim geçişlerinde temizliği gereken yorganlarınız için profesyonel, hijyenik ve güvenilir temizlik çözümleri sunuyoruz.
            </p>

            <p>
              Yorganlar, hacimli yapıları nedeniyle evde yıkanması zor ürünlerdir. Özellikle makinede yıkanamayan, elyaf veya yün dolgulu yorganlar profesyonel bakım ister. Biz de bu özel ürünler için türüne uygun yıkama yöntemleri uyguluyoruz.
            </p>

            <p>
              Özel sanayi tipi yorgan yıkama makinelerimiz, yüksek hijyen sağlayan deterjanlarımız ve deneyimli personelimiz ile yorganlarınızı tertemiz ve mis kokulu hale getiriyoruz.
            </p>

            <p>
              Adresinizden teslim aldığımız yorganlarınızı yıkayıp kuruttuktan sonra, hijyenik ambalaj içerisinde geri teslim ediyoruz. Tüm süreç boyunca ürünlerinize özenle davranıyoruz.
            </p>

            <p>
              İstanbul genelinde ücretsiz servis imkanıyla, yorgan yıkama hizmetimizden 7/24 randevu alabilirsiniz. Whatsapp hattımızdan hemen ulaşabilirsiniz.
            </p>

            <h2 className="text-xl font-bold text-[#003132]">🛌 Profesyonel Yorgan Yıkama Hizmeti</h2>
            <p>
              Yorganlarınız zamanla ter, toz, akar ve bakterilerle dolar. Yıkama işlemi sırasında hem görünür hem görünmeyen kirlerden tamamen arındırılır. İlk günkü hijyeni yeniden kazanır.
            </p>

            <h2 className="text-xl font-bold text-[#003132]">💧 Yorgan Yıkama Sürecimiz</h2>
            <ol className="list-decimal list-inside space-y-2">
              <li>Yorgan türü ve dolgu malzemesine göre sınıflandırma</li>
              <li>Toz ve yüzey temizliği</li>
              <li>Ön leke analizi ve müdahale</li>
              <li>Endüstriyel makinelerde düşük ısıda yıkama</li>
              <li>Doğal kurutma veya hava kontrollü kurutma</li>
              <li>Son kalite kontrol ve özel ambalajlama</li>
              <li>Adresinize teslimat</li>
            </ol>

            <h2 className="text-xl font-bold text-[#003132]">🧴 Kullandığımız Ürünler</h2>
            <ul className="list-disc list-inside">
              <li>Elyaf ve yün yorganlara özel deterjanlar</li>
              <li>Antibakteriyel ve koku giderici temizlik ürünleri</li>
              <li>Hassas dokulara zarar vermeyen doğal içerikler</li>
            </ul>

            <h2 className="text-xl font-bold text-[#003132]">✅ Neden Bizi Tercih Etmelisiniz?</h2>
            <ul className="list-disc list-inside">
              <li>Yorgan türüne uygun yıkama sistemleri</li>
              <li>Modern makineler ve uzman personel</li>
              <li>Ücretsiz servis ve zamanında teslimat</li>
              <li>Hijyen garantili temizlik</li>
              <li>Uygun fiyatlarla profesyonel hizmet</li>
            </ul>

            <p>
              Yorganlarınızın hijyenini profesyonellere bırakın. Sağlıklı bir uyku ve uzun ömürlü yorgan kullanımı için bize güvenin. Hemen iletişime geçin, yorganlarınızı tertemiz teslim edelim.
            </p>
          </div>

          {/* Mobilde sola düşen sidebar */}
          <div className="block lg:hidden mt-10">
            <LeftSidebar />
          </div>
        </main>

        {/* Sağ Sidebar */}
        <div className="w-full">
          <RightSidebar />
        </div>
      </div>
    </>
  );
};

export default Quilt;
